import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { User } from "src/_common/interfaces/models/user";
import { ACTIONS } from "src/_config";

export interface UserReducer {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  guestUserId?: string | null;
  pickIds?: string[] | null;
}

const initialState: UserReducer = {
  user: null,
  token: null,
  isAuthenticated: false,
  guestUserId: null,
  pickIds: null,
};

const userReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.AUTH.LOGIN:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
      };
    case ACTIONS.AUTH.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
      };
    case ACTIONS.AUTH.ME:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };

    case ACTIONS.AUTH.UPDATE_DISPLAY_NAME: {
      const displayName = action.payload;
      const editedUser: any = { ...state.user };
      editedUser["display_name"] = displayName;
      return {
        ...state,
        user: editedUser,
      };
    }
    case ACTIONS.AUTH.SET_GUEST_USER_ID:
      return {
        ...state,
        guestUserId: action.payload,
      };
    case ACTIONS.AUTH.UPDATE_DOB: {
      const dob = action.payload;
      const editedUserDob: any = { ...state.user };
      editedUserDob["dob"] = dob;
      return {
        ...state,
        user: editedUserDob,
      };
    }
    case ACTIONS.AUTH.UPDATE_EMAIL: {
      const email = action.payload;
      const editedUserEmail: any = { ...state.user };
      editedUserEmail["email"] = email;
      return {
        ...state,
        user: editedUserEmail,
      };
    }
    case ACTIONS.AUTH.SET_PICK_IDS: {
      let newPickId: any = state.pickIds || [];
      if (action.payload && ((newPickId && !newPickId.includes(action.payload)) || !newPickId)) {
        newPickId.push(action.payload);
      } else if (!action.payload) {
        newPickId = null;
      }
      return {
        ...state,
        pickIds: newPickId,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
